import { Pipe, PipeTransform } from '@angular/core';

import {
  QUOTE_STATUSES,
  QuoteStatus,
  Role,
  RoleType,
} from '@lockton-apps/shared/interfaces';
import { cond, constant, stubTrue } from 'lodash';

/** @deprecated use new workflow pipes */
@Pipe({
  name: 'quoteStatusIcon',
  standalone: true,
})
export class QuoteStatusIconPipe implements PipeTransform {
  contactMap = new Map<QuoteStatus, string>([
    [QUOTE_STATUSES.FormInitialized, 'application_progress'],
    [QUOTE_STATUSES.FormSent, 'renewal'], // Applicable to ACCA Under only
    [QUOTE_STATUSES.FormIncomplete, 'application_progress'],
    [QUOTE_STATUSES.FormComplete, 'application_complete'],
    [QUOTE_STATUSES.OnHold, 'exclaim'],
    [QUOTE_STATUSES.HealthEvaluationRequired, 'health_evaluation_thin'],
    [QUOTE_STATUSES.HealthEvaluationActive, 'health_evaluation_thin'],
    [QUOTE_STATUSES.Quoted, 'quote_universal_thin'],
    [QUOTE_STATUSES.BrokerApproved, 'quote_universal_sent_thin'],
    [QUOTE_STATUSES.AwaitingPayment, 'payment_progress'],
    [QUOTE_STATUSES.Complete, 'renewal_complete'],
    [QUOTE_STATUSES.QuoteError, 'quote_error'],
  ]);
  brokerMap = new Map<QuoteStatus, string>([
    [QUOTE_STATUSES.FormInitialized, 'application_progress'],
    [QUOTE_STATUSES.FormIncomplete, 'application_progress'],
    [QUOTE_STATUSES.FormSent, 'quote_universal_sent_thin'],
    [QUOTE_STATUSES.FormComplete, 'application_complete'],
    [QUOTE_STATUSES.OnHold, 'on_hold'],
    [QUOTE_STATUSES.HealthEvaluationRequired, 'health_evaluation_thin'],
    [QUOTE_STATUSES.HealthEvaluationActive, 'health_evaluation_thin'],
    [QUOTE_STATUSES.Quoted, 'quote_universal_thin'],
    [QUOTE_STATUSES.BrokerApproved, 'quote_universal_sent_thin'],
    [QUOTE_STATUSES.QuoteAccepted, 'quote_universal_accepted_thin'],
    [QUOTE_STATUSES.AwaitingPayment, 'quote_universal_accepted_thin'],
    [QUOTE_STATUSES.Complete, 'quote_universal_accepted_thin'],
    [QUOTE_STATUSES.QuoteError, 'quote_error'],
  ]);

  transform(value: QuoteStatus, role: RoleType = Role.Contact): string {
    return (
      cond([
        [() => role === Role.Contact, constant(this.contactMap.get(value))],
        [stubTrue, constant(this.brokerMap.get(value))],
      ])() || 'help'
    );
  }
}
